<div class="page">
  <div class="content">
    <!-- Navigation and Status Tabs -->
    <div class="status-nav">
      <div class="status-tabs">
        <a
          class="tab"
          [class.active]="currentStatus === 'all'"
          (click)="filterByStatus('all')"
          matTooltip="{{ getTotalCount() }} total invitations"
          matTooltipClass="black-tooltip"
          matTooltipPosition="above"
          #tooltip="matTooltip"
          (click)="tooltip.show()"
        >
          All <span class="count">{{ getTotalCount() }}</span>
        </a>
        <a
          class="tab"
          [class.active]="currentStatus === 'delivered'"
          (click)="filterByStatus('delivered')"
          [matTooltip]="getStatusCount('delivered') + '/' + getTotalCount() + ' (' + getStatusPercentage('delivered') + ')'"
          matTooltipClass="black-tooltip"
          matTooltipPosition="above"
        >
          Delivered <span class="count">{{ getStatusCount('delivered') }}</span>
        </a>
        <a
          class="tab"
          [class.active]="currentStatus === 'accepted'"
          (click)="filterByStatus('accepted')"
          [matTooltip]="getStatusCount('accepted') + '/' + getTotalCount() + ' (' + getStatusPercentage('accepted') + ')'"
          matTooltipClass="black-tooltip"
          matTooltipPosition="above"
        >
          Accepted <span class="count">{{ getStatusCount('accepted') }}</span>
        </a>
        <a
          class="tab"
          [class.active]="currentStatus === 'declined'"
          (click)="filterByStatus('declined')"
          [matTooltip]="getStatusCount('declined') + '/' + getTotalCount() + ' (' + getStatusPercentage('declined') + ')'"
          matTooltipClass="black-tooltip"
          matTooltipPosition="above"
        >
          Declined <span class="count">{{ getStatusCount('declined') }}</span>
        </a>

        <a
          class="tab error-status"
          [class.active]="currentStatus === 'bounced'"
          (click)="filterByStatus('bounced')"
          [matTooltip]="getStatusCount('bounced') + '/' + getTotalCount() + ' (' + getStatusPercentage('bounced') + ')'"
          matTooltipClass="black-tooltip"
          matTooltipPosition="above"
          data-status="bounced"
        >
          Bounced <span class="count">{{ getStatusCount('bounced') }}</span>
        </a>
        <a
          class="tab error-status"
          [class.active]="currentStatus === 'reported'"
          (click)="filterByStatus('reported')"
          [matTooltip]="getStatusCount('reported') + '/' + getTotalCount() + ' (' + getStatusPercentage('reported') + ')'"
          matTooltipClass="black-tooltip"
          matTooltipPosition="above"
          data-status="reported"
        >
          Reported <span class="count">{{ getStatusCount('reported') }}</span>
        </a>
        <a
          class="tab error-status"
          [class.active]="currentStatus === 'invalid'"
          (click)="filterByStatus('invalid')"
          [matTooltip]="getStatusCount('invalid') + '/' + getTotalCount() + ' (' + getStatusPercentage('invalid') + ')'"
          matTooltipClass="black-tooltip"
          matTooltipPosition="above"
          data-status="invalid"
        >
          Invalid <span class="count">{{ getStatusCount('invalid') }}</span>
        </a>
      </div>
      <div class="search-container">
        <mat-icon>search</mat-icon>
        <input type="text" class="search-input" placeholder="Search by Name/Email" (input)="onSearch($event)" />
      </div>
    </div>

    <!-- Table Container -->
    <div class="table-container">
      <!-- Loading State -->
      <div class="loading-state" *ngIf="isLoading">
        <mat-spinner diameter="40"></mat-spinner>
      </div>

      <!-- Table -->
      <cdk-virtual-scroll-viewport itemSize="48" class="table-viewport" (scroll)="onScroll($event)" [minBufferPx]="200" [maxBufferPx]="400">
        <table mat-table [dataSource]="dataSource" class="mat-mdc-table">
          <!-- Info Columns Group -->
          <ng-container matColumnDef="fullname">
            <th mat-header-cell *matHeaderCellDef class="mat-mdc-header-cell info-column">Full Name</th>
            <td mat-cell *matCellDef="let invitation" class="mat-mdc-cell info-column">{{ invitation.fullname }}</td>
          </ng-container>

          <ng-container matColumnDef="email">
            <th mat-header-cell *matHeaderCellDef class="mat-mdc-header-cell info-column">Email</th>
            <td mat-cell *matCellDef="let invitation" class="mat-mdc-cell info-column">{{ invitation.email }}</td>
          </ng-container>

          <ng-container matColumnDef="from_event_name">
            <th mat-header-cell *matHeaderCellDef class="mat-mdc-header-cell info-column">Invited From</th>
            <td mat-cell *matCellDef="let invitation" class="mat-mdc-cell info-column">{{ invitation.from_event_name }}</td>
          </ng-container>

          <!-- Status Columns Group -->
          <ng-container matColumnDef="delivered">
            <th mat-header-cell *matHeaderCellDef class="mat-mdc-header-cell status-column">Delivered</th>
            <td mat-cell *matCellDef="let invitation" class="mat-mdc-cell status-column">
              <mat-icon
                *ngIf="
                  invitation.status_text?.toLowerCase() === 'accepted' ||
                  invitation.status_text?.toLowerCase() === 'declined' ||
                  invitation.status_text?.toLowerCase() === 'reported' ||
                  invitation.status_text?.toLowerCase() === 'delivered'
                "
                class="status-check"
                >check</mat-icon
              >
            </td>
          </ng-container>

          <ng-container matColumnDef="registration">
            <th mat-header-cell *matHeaderCellDef class="mat-mdc-header-cell status-column">Accepted</th>
            <td mat-cell *matCellDef="let invitation" class="mat-mdc-cell status-column">
              <mat-icon *ngIf="invitation.status_text?.toLowerCase() === 'accepted'" class="status-check">check</mat-icon>
            </td>
          </ng-container>

          <ng-container matColumnDef="declined">
            <th mat-header-cell *matHeaderCellDef class="mat-mdc-header-cell status-column">Declined</th>
            <td mat-cell *matCellDef="let invitation" class="mat-mdc-cell status-column">
              <mat-icon *ngIf="invitation.status_text?.toLowerCase() === 'declined'" class="status-check error-status">check</mat-icon>
            </td>
          </ng-container>

          <ng-container matColumnDef="bounced">
            <th mat-header-cell *matHeaderCellDef class="mat-mdc-header-cell status-column">Bounced</th>
            <td mat-cell *matCellDef="let invitation" class="mat-mdc-cell status-column">
              <mat-icon *ngIf="invitation.status_text?.toLowerCase() === 'bounced'" class="status-check error-status">check</mat-icon>
            </td>
          </ng-container>

          <ng-container matColumnDef="reported">
            <th mat-header-cell *matHeaderCellDef class="mat-mdc-header-cell status-column">Reported</th>
            <td mat-cell *matCellDef="let invitation" class="mat-mdc-cell status-column">
              <mat-icon *ngIf="invitation.status_text?.toLowerCase() === 'reported'" class="status-check error-status">check</mat-icon>
            </td>
          </ng-container>

          <ng-container matColumnDef="invalid">
            <th mat-header-cell *matHeaderCellDef class="mat-mdc-header-cell status-column">Invalid</th>
            <td mat-cell *matCellDef="let invitation" class="mat-mdc-cell status-column">
              <mat-icon *ngIf="invitation.status_text?.toLowerCase() === 'invalid'" class="status-check error-status">check</mat-icon>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true" class="mat-mdc-header-row"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns" class="mat-mdc-row"></tr>

          <!-- No Results Row -->
          <tr class="mat-mdc-row" *matNoDataRow>
            <td class="mat-mdc-cell" [attr.colspan]="displayedColumns.length">
              <div class="no-results">
                <mat-icon>info</mat-icon>
                <span>No invitations found</span>
              </div>
            </td>
          </tr>
        </table>
      </cdk-virtual-scroll-viewport>
    </div>
  </div>
</div>
